import { render, staticRenderFns } from "./BindPassword.vue?vue&type=template&id=0494db43&scoped=true"
import script from "./BindPassword.vue?vue&type=script&lang=js"
export * from "./BindPassword.vue?vue&type=script&lang=js"
import style0 from "./BindPassword.vue?vue&type=style&index=0&id=0494db43&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0494db43",
  null
  
)

export default component.exports